// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import $ from 'jquery'; 
import moment from 'moment';
import Loading from '../Loading.js';
import { capitalizeFLetter, ajaxPerso, findWherePosted, fetchMenu, menuOrganized, fetchItems } from '../../../fnc.js'

const refConst = require("../../../constants.js").v

export default function PMAFromSelection(props){

	const initialState = {
		submited: false,
		result: null,
		products: null
	}

	const refTitle = useRef(null)
	const refModalState = useRef(null)
	const [refreshView, setRefreshView] = useState(0);
	const [submited, setSubmited] = useState(initialState.submited);
	const [result, setResult] = useState(initialState.result);
	const [products, setProducts] = useState(initialState.products);

	useEffect(() => {
		return () => {
			if(window.intervalTagGestion)
				clearInterval(window.intervalTagGestion)
		}
	}, [])

	useEffect(() => {

		if(!props.itemsSelected || !refModalState.current)	return;
		
		fetchItems("eio", {
			"idProductListJson": JSON.stringify(props.itemsSelected)
		}, (r) => {
			console.info("fetchItems_111", r);
			if(r.error){
				props.info({error: r.error})
			}else{
				setProducts(r.data)
			}
		})

	}, [props.itemsSelected && refModalState.current])

	useEffect(() => {

		if(!result || !result.ids || !props.itemsSelected)	return;

		fetchItems("eio", {
			"idProductListJson": JSON.stringify(props.itemsSelected)
		}, (r) => {
			console.info("fetchItems_111", r);
			if(r.error){
				props.info({error: r.error})
			}else{
				setProducts(r.data)
			}
		})
		
	}, [result, props.itemsSelected])

	useEffect(() => {

		if(!result || !result.ids || !props.itemsSelected || !products)	return;

		addPmaData(result.ids[0], props.itemsSelected)
		
	}, [products])

	useEffect(() => {
		if(refModalState.current)
			modalTrigger(true);
	}, [props.store, refModalState.current, result, products])

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}

	let createPma = (callback) => {

		if(!refTitle.current || !refTitle.current.value){
			alert("Please enter a title")
			return;
		}
		props.loading(true)
		ajaxPerso( Object.assign({
			"api": "eio",
			"trigger": "setPMA",
			"title": refTitle.current.value,
			"uid": props.getUser().uid,
		}), (r) => {
			console.info("PMAFromSelection", r);
			if(callback)	callback(r)
			if(!r.errors){
				setResult(r.res)
				refTitle.current.value = ""
			}else{
				props.loading(false)
			}
		});
	}

	let addPmaData = (id_pma, idProductList, callback) => {

		if(!id_pma || !idProductList || idProductList.length === 0){
			alert("Please enter a id_pma/idProductList")
			return;
		}
		let data = []
		idProductList.forEach((id) => {
			let findProduct = products.find(p => p.id === id)
			data.push({
				"id_pma": id_pma,
				"id_product": id,
				"static_weight": findProduct?.weight,
				"static_weight_unit": findProduct?.weight_unit,
				"static_cost": findProduct?.cost,
				"static_map": findProduct?.map_price,
			})
		})
		ajaxPerso( Object.assign({
			"api": "eio",
			"trigger": "setPMAData",
			"data": JSON.stringify(data),
		}), (r) => {
			console.info("setPMAData", r);
			props.loading(false)
			if(callback)	callback(r)
			if(r.errors){
				props.info({"error": JSON.stringify(r.errors)})
			}
		});
	}

	let modalTrigger = (refresh) => {
		props.modal({
			show: refresh? false : true,
			title: "PMA Creator",
			html: (close) => {
				return <div className="">
					{
						props.itemsSelected.length > 0? <div className="alert alert-primary" role="alert">
							You have selected {props.itemsSelected.length} items
						</div> : <div className="alert alert-warning" role="alert">
							You need to selected items first
						</div>
					}
					<form onSubmit={(e) => {
						e.preventDefault()
						setSubmited(true)
						createPma(() => {
							setSubmited(false)
						})
					}}>
						<div className="input-group mb-3">
							<div className="input-group-prepend">
								<span className="input-group-text" id="basic-addon1">Title</span>
							</div>
							<input type="text" className="form-control" placeholder="Title" ref={refTitle}/>
							<div className="input-group-append">
								<button className="btn btn-outline-secondary" type="submit">Create</button>
							</div>
						</div>
					</form>
					<div className="d-flex justify-content-center">
						{
							!result? <button className="btn btn-primary mr-2" onClick={() => {
								createPma()
							}}>Create PMA</button> : ""
						}
						<button className="btn btn-secondary ml-2" onClick={() => {
							close()
							props.parent.history.push(`/pmalist`)
						}}>Go to PMA List</button>
						{
							result && result.ids? <button className="btn btn-success ml-2" onClick={() => {
								let idPma = result && result.ids.length > 0? result.ids[0] : 0
								close()
								props.parent.history.push(`/pma/${idPma}`)
							}}>Open your new PMA</button> : ""
						}
					</div>
				</div>
			}
			, exit: (popup, close) => {
				console.info("window.intervalTagGestion", window.intervalTagGestion);
				refModalState.current = false
				if(window.intervalTagGestion)
					clearInterval(window.intervalTagGestion)
				close()
			}
			, ok: false
		});
	}

	let storeFromToNames = () => {
		if(props.stores.length === 0)	return ""
		
		let store = null;
		store = props.stores.find(o => {
			if(o.id === props.store)	return o
		})

		if(store)
			return store.name
		else
			return "PMA Creator"
	}

	console.info("SSSSSSSSSSAAA", props);

	return (
		<button className={"classname" in props && props.classname? props.classname : "btn btn-outline-primary"} onClick={() => {
			refModalState.current = true
			resetPage()
			modalTrigger()
		}}>
			{
				storeFromToNames()
			}
		</button>
	);
}